import styled from 'styled-components';
import { DialogContent, TextField } from '@mui/material';

import colors from '../../../../styles/colors';

const Title = styled.h2``;

const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.shades.gamma7};
  margin-top: -16px;
`;

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 400px;
  padding: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
`;

const GroupContainer = styled.li`
  list-style: none;
`;

const GroupHeader = styled.div`
  padding: 4px 10px;
  font-weight: bold;
`;

const GroupList = styled.ul`
  padding: 0;
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 20px;
  width: 100%;
`;

export {
  Title,
  Description,
  StyledDialogContent,
  ButtonContainer,
  GroupContainer,
  GroupHeader,
  GroupList,
  StyledTextField,
};
